<div class="detail">
  <div class="mb-10">
    <gmt-button uiSref="^"><i class="fa fa-chevron-left mr-5"></i> Zpět na případ</gmt-button>
  </div>
  <h1>{{ acceptedGeometricalPlanPossibleName }}</h1>
  <div [loading]="loading" *ngIf="loading"></div>
  <div *ngIf="!loading">
    <form-accepted-geometrical-plan-possible [data]="data" (callbackRegister)="formCallbackRegister($event)"></form-accepted-geometrical-plan-possible>

    <div>
      <gmt-button [clickAction]="onSubmit" [gmtDisabled]="!isValid()">Uložit</gmt-button>
    </div>
  </div>
</div>
